import { useMemo } from "react";
import { useComponentsTranslation } from "../i18n/i18next.ts";
import { formatDaysAgo, formatDaysCount } from "./dates.ts";

export function useDaysFormatters() {
    const { t, i18n } = useComponentsTranslation();
    const { language } = i18n;

    return useMemo(
        () => ({
            formatDaysAgo: (date: string | Date | number) => formatDaysAgo(date, language),
            formatDaysCount: (days: number) => formatDaysCount(days, t)
        }),
        [language, t]
    );
}

export type DaysFormatters = ReturnType<typeof useDaysFormatters>;
